var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-container bottom-bar"},[_c('price'),_c('quantity-selector'),_c('div',{staticClass:"button-actions"},[_c('add-to-cart')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }